//useDownloadRequestQuery
import { useQuery, UseQueryOptions } from 'react-query';

import { DataRoomDownloadRequest, Deal, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDownloadRequestQuery(
	dataRoomGuid: Guid | undefined,
	userGuid: Guid | undefined,
	options?:
		| Omit<
				UseQueryOptions<DataRoomDownloadRequest[], unknown, DataRoomDownloadRequest[], any>,
				'queryKey' | 'queryFn'
		  >
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.DownloadRequests(dataRoomGuid, userGuid),
		() =>
			AxiosUtils.getResponseData<DataRoomDownloadRequest[]>(
				api.get(CerebroApiEndpoints.DataRooms.DownloadRequests(dataRoomGuid, userGuid))
			),
		options
	);
}
